import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'

import { GroupsTable } from './table-components/GroupsTable'
import { GroupDialog } from './components/GroupDialog'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'
import { Button } from '@/components/shadcn/button'
import { Plus } from 'lucide-react'
import { usePermissions } from '@/hooks/usePermissions'
import {type ExtendedGroupResponse, PermissionEntityType} from "@/api/model";


export default function GroupsPage() {
  const { t } = useTranslation('groups')
  const { userHasPermission } = usePermissions()
  // Groups only expose View/Create — Create is the single write grant.
  const canWrite = userHasPermission(PermissionEntityType.Groups, 'Create')
  const [createOpen, setCreateOpen] = useState(false)
  const [editing, setEditing] = useState<ExtendedGroupResponse | null>(null)

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}>
        <PageHeaderActions>
          <Button className="gap-2" onClick={() => setCreateOpen(true)} disabled={!canWrite}>
            <Plus className="h-4 w-4" />
            <span className="hidden sm:inline">{t('actions.create')}</span>
          </Button>
        </PageHeaderActions>
      </PageHeader>

      <GroupsTable onEdit={setEditing} canWrite={canWrite} />

      <GroupDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      />
      <GroupDialog
        open={!!editing}
        onClose={() => setEditing(null)}
        editing={editing}
      />
    </PageLayout>
  )
}
